import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Tools.module.scss';

export const ToolsStepFour = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.toolsLeftSection}>
        <span className={styles.toolsStepLeft_1}>TransparenTerra’s</span>
        <span className={styles.toolsStepLeft_2}>Tools</span>
        <span className={styles.toolsStepLeft_3}>and</span>
        <span className={styles.toolsStepLeft_4}>principles</span>
      </div>
    }
    rightContent={
      <div className={styles.toolsStepContentWrapper}>
        <p style={{ marginBottom: 40 }}>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>A sustainable Marketplace</div>
          Vendors in the TransparenTerra marketplace provide users with all data about the raw
          materials they use, logistics, certificates, and other documents. Buyers can always know
          exactly what they’re purchasing.
        </p>
        <p>
          <div style={{ marginBottom: 8, fontWeight: 600 }}>An NFT/NFA platform</div>
          The NFT/NFA platform supports owners of tokenized assets worldwide. Choose the best
          solution to digitize your company or products and get maximum benefits from the digital
          economy.
        </p>
      </div>
    }
  />
);
